export const ENGAGE_DEMO_IMG = "https://s3.amazonaws.com/everfi-content/engage-demo.jpg";
